import { createContext, useContext, type ReactNode } from 'react'

export interface NotificationContextValue {
  readonly enqueueSnackbar: (
    message: ReactNode,
    options?: {
      readonly autoHideDuration?: number
      readonly variant?: 'default' | 'error' | 'info' | 'success' | 'warning'
    },
  ) => number
}

export const NotificationContext = createContext<NotificationContextValue | null>(null)

export function useSnackbar() {
  const context = useContext(NotificationContext)
  if (!context) throw new Error('useSnackbar must be used within NotificationProvider')
  return context
}
